<oo-side-overlay-wrapper title="Statistics">
  <oo-loading-container [status]="state.status">
    <ng-template>
      <mat-form-field appearance="fill">
        <mat-label>Select Teams</mat-label>
        <mat-select [formControl]="state.teamsFilter" multiple>
          @for (prop of state.teamsLookup | keyvalue; track prop) {
            <mat-option
              [value]="+prop.key">
              {{ prop.value.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (match of state.filteredMatches; track match) {
        <div class="oo-match">
          <h4>
            <b>{{ match.homeTeam.name }} vs {{ match.awayTeam.name }}</b>
          </h4>
          @for (result of match.results; track result) {
            <div class="oo-result">
              <span>{{ result[0] }}:</span>
              <span>{{ result[1] }}</span>
            </div>
          }
        </div>
      }
    </ng-template>
  </oo-loading-container>
</oo-side-overlay-wrapper>
